<template>
  <div class="bg-gray-800 rounded-t-none rounded-lg pb-2">
    <div class="px-3 py-3">Mettre les contributions du label supprimé dans :</div>
    <button
      @click="handleDelete()"
      class="flex p-3 bg-gray-700 font-light text-white text-base w-full focus:outline-none"
    >
      <img class="h-6 pr-2" src="../../assets/icons/bin-red.svg" alt="Supprimer le label" />
      Supprimer
    </button>
    <ul class="text-sm select-none" sortable>
      <li
        v-for="(label, index) in labels.filter((label, index) => index != editedIndex && label.is_default === false)"
        :key="label.guid_text"
        :id="index"
        class="flex items-center justify-between p-3 focus:outline-none"
        :class="[index % 2 ? 'bg-gray-700' : 'bg-gray-800']"
        style="width:256px"
        @click="handleDelete(label)"
      >
        <div class="w-full flex items-center cursor-pointer">
          <div
            class="flex items-center justify-center text-gray-600 w-6 h-6 rounded-full"
            :style="
              'background-color:' +
                getLabelColors(label.guid_text).bg +
                '; color:' +
                getLabelColors(label.guid_text).font
            "
          >
            {{ label.initials }}
          </div>
          <div class="pl-2">
            {{ label.text }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex"

export default {
  props: {
    editedIndex: Number,
  },
  computed: {
    ...mapGetters("labels", ["getLabelColors"]),
    ...mapState({
      labels: (state) => state.labels.all,
    }),
  },
  methods: {
    ...mapActions("labels", ["deleteLabel"]),
    handleDelete(toLabel = null) {
      this.deleteLabel({ index: this.editedIndex, toLabel: toLabel })
      this.$emit("closeMenu")
    },
  },
}
</script>

<style></style>
